import React, {PureComponent} from "react"

import id from "@irati/utils/id"
import {injectIntl} from "@irati/utils/lang"

import {SavingBlock, SavingProps} from "./SavingBlock"
import SavingsWrapper from "./styled/SavingsWrapper"

class Saving extends PureComponent<SavingProps> {
  render() {
    if (!this.props.deal) return null

    const idNamespace = id("saving", {id: this.props.deal.uuid})

    return (
      <SavingsWrapper id={id("savings-wrapper", idNamespace)} data-test="savings">
        <SavingBlock {...this.props} />
      </SavingsWrapper>
    )
  }
}

export default injectIntl(Saving)
